export default __webpack_public_path__ + "assets/images/fa426c78541f83e945cf88fbf97f0b53.png";